import { TrackJS } from 'trackjs';

export const log = {
  // ...args: any because console.info(...) receives ...args: any
  // oxlint-disable-next-line typescript/no-explicit-any
  info: (...args: any) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.info(...args);
    } else {
      // oxlint-disable-next-line no-console
      console.info(...args);
    }
  },
  // ...args: any because console.error(...) receives ...args: any
  // oxlint-disable-next-line typescript/no-explicit-any
  error: (...args: any) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.error(...args);
    } else {
      // oxlint-disable-next-line no-console
      console.error(...args);
    }
  },
};
